import { render, staticRenderFns } from "./panel_jiedai.vue?vue&type=template&id=253ec605&scoped=true&"
import script from "./panel_jiedai.vue?vue&type=script&lang=js&"
export * from "./panel_jiedai.vue?vue&type=script&lang=js&"
import style0 from "./panel_jiedai.vue?vue&type=style&index=0&id=253ec605&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ec605",
  null
  
)

export default component.exports